import i18n from "../../../../i18n/i18n";
import {ValidatedValue} from "../../../../helpers/validatedValue";
import "./dateAndTime.scss";
import {observer} from "mobx-react";
import Date from "./date";
import Time from "./time";

interface DataAndTimeProps {
    testId: string;
    dateLabel: string;
    dateValue: ValidatedValue<Date | null>;
    onChangeDate: (date: Date | null) => void;
    hourValue: ValidatedValue<Date | null>;
    onChangeHour: (date: Date | null) => void;
    disabled?: boolean;
}

function DateAndTime(props: DataAndTimeProps) {

    return (
        <div className="date-and-time">
            <Date
                testId={`${props.testId}-date`}
                dateLabel={props.dateLabel}
                dateValue={props.dateValue}
                onChangeDate={props.onChangeDate}
                disabled={props.disabled}
            />
            <Time
                testId={`${props.testId}-time`}
                timeLabel={i18n.t("timetable.headers.time")}
                hourValue={props.hourValue}
                onChangeHour={props.onChangeHour}
                disabled={props.disabled}
            />
        </div>
    );
}

export default observer(DateAndTime);
